import React from "react";
import { connect } from "react-redux";
import { Tabs } from "../../components/Tabs";
import AnnualPlan from "../../components/Reports/bloodCollection/AnnualPlan";
import ABCPReport from "../../components/Reports/bloodCollection/ABCPReport";
import ABCPPreparation from "../../components/Reports/bloodCollection/ABCPPreparation";
import ABCPlanningManager from "../../components/Reports/bloodCollection/ABCPlanningManager";
import BloodCollectionDailyPlan from "../../components/Reports/btdActivityBook/BloodCollectionDailyPlan";
import CorneaRetrievalPlan from "../../components/Reports/btdActivityBook/CorneaRetrievalPlan";
import HemovigilancePlan from "../../components/Reports/btdActivityBook/HemovigilancePlan";
import FieldActivityPlan from "../../components/Reports/btdActivityBook/FieldActivityPlan";

class PlanningScreen extends React.Component {
  render() {
    const tabOptions = [
      {
        title: "Annual Plan",
        data: <AnnualPlan />,
      },
      {
        title: "A. Blood Collection Daily Plan",
        data: <BloodCollectionDailyPlan />,
      },
      {
        title: "B. Cornea Retrieval Plan",
        data: <CorneaRetrievalPlan />,
      },
      {
        title: "C. Hemovigilance Plan",
        data: <HemovigilancePlan />,
      },
      {
        title: "D. Field Activity Plan",
        data: <FieldActivityPlan />,
      },
      {
        title: "ABC Planning",
        data: <ABCPReport />,
      },
      {
        title: "ABCP Preparation",
        data: <ABCPPreparation />,
      },
      {
        title: "New ABC Planning",
        data: <ABCPlanningManager />,
      },
    ];

    return (
      <div>
        <div className="card-dashboard-content">
          <div className="card-body">
            <Tabs options={tabOptions} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return { defaultLanguage };
};

export default connect(mapStateToProps)(PlanningScreen);
